import * as React from 'react';

const ChevronRightBlackSvg = props => (
    <svg width={16} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M6.667 5.166v6.667L10 8.5 6.667 5.166Z" fill="#111" />
    </svg>
);

export default ChevronRightBlackSvg;
